/**
 * @deprecated
 * use from v2/new-design-system
 */

export enum AtomButtonSizeEnum {
  SM = "sm",
  MD = "md",
}
